
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { ShowErrorsComponent } from './../Component/show-errors/show-errors.component';
import { AppPaginationComponent } from './../Component/app-pagination/app-pagination.component';


import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Routing Module
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [ShowErrorsComponent, AppPaginationComponent],
   exports: [
    ShowErrorsComponent,
    CommonModule,
    ReactiveFormsModule,
     FormsModule,
     AppPaginationComponent
   ]
})
export class SharedModuleModule { }
